import { NavLink } from 'react-router-dom'
import { Home, Calendar, User, Briefcase, Building2, Bell } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import { useLang } from '../../contexts/LangContext'

interface NavItem {
  to: string
  icon: React.ReactNode
  label: string
}

export default function BottomNav() {
  const { currentUser } = useAuth()
  const { t } = useLang()

  if (!currentUser || currentUser.admin) return null

  const customerItems: NavItem[] = [
    { to: '/dashboard', icon: <Home size={22} />, label: t('Dashboard', 'Dashboard') },
    { to: '/book', icon: <Calendar size={22} />, label: t('Κράτηση', 'Book') },
    { to: '/bookings', icon: <Briefcase size={22} />, label: t('Κρατήσεις', 'Bookings') },
    { to: '/properties', icon: <Building2 size={22} />, label: t('Ακίνητα', 'Properties') },
    { to: '/settings', icon: <User size={22} />, label: t('Εγώ', 'Me') },
  ]

  const providerItems: NavItem[] = [
    { to: '/provider/dashboard', icon: <Home size={22} />, label: t('Αρχική', 'Home') },
    { to: '/provider/bookings', icon: <Calendar size={22} />, label: t('Κρατήσεις', 'Bookings') },
    { to: '/provider/availability', icon: <Briefcase size={22} />, label: t('Ωράριο', 'Schedule') },
    { to: '/notifications', icon: <Bell size={22} />, label: t('Ειδοποιήσεις', 'Alerts') },
    { to: '/settings', icon: <User size={22} />, label: t('Εγώ', 'Me') },
  ]

  const items = currentUser.role === 'provider' ? providerItems : customerItems

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-40 pb-safe">
      <div className="flex">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-xs font-medium transition-colors ${
                isActive ? 'text-primary-600' : 'text-slate-400'
              }`
            }
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
